// extracted by mini-css-extract-plugin
module.exports = {"content":"LearningPlatform_content__1TeHC","text":"LearningPlatform_text__3fN0q"};